import { handleFormChange } from "@/utils/formChange";
import { FormEvent, ReactNode } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { formInterface, select, staticSelect } from "@/interface/dataInterface";
import SelectFinal from "./Select";
import DatePicker from "./DatePicker";
import StaticDataSelect from "./StaticDataSelect";

interface input {
  id: string;
  label: string;
  type?: string;
  value: string;
  placeholder?: string;
  required?: boolean;
  setProp: Function;
  children?: ReactNode;
  disabled?: boolean;
  readonly?: boolean;
  max?: number;
  pattern?: string;
}

interface inputGroup extends input {
  width?: string;
  children?: ReactNode;
}

interface baseSelect extends select {
  label: string;
}

interface baseStaticSelect extends staticSelect {
  label: string;
  disabled?: boolean;
} 

export function BaseInput({id, label, type, value, placeholder, setProp, required = true, disabled = false, readonly = false, max}: input) {
  return (
    <div className="w-full">
      <Label htmlFor={id} className="text-right mb-2">
        {label} {required != false && "*"}
      </Label>
      <Input
        id={id}
        name={id}
        type={type || "text"}
        value={value}
        onChange={(e: FormEvent<HTMLInputElement>) =>
          handleFormChange(e, setProp)
        }
        placeholder={placeholder || `Enter ${id} value`}
        required={required}
        disabled={disabled}
        readOnly={readonly}
        max={max}
      />
    </div>
  );
}

export function BaseInputGroup({
  id,
  label,
  type,
  value,
  placeholder,
  required = true,
  readonly = false,
  setProp,
  width,
  children,
}: inputGroup) {
  return (
    <div className="relative w-full">
      <BaseInput
        id={id}
        label={label}
        type={type || "text"}
        value={value}
        placeholder={placeholder || `Enter ${id} value`}
        required={required}
        readonly={readonly}
        setProp={setProp}
      />
      <div className={`absolute bottom-0 right-0 ${width || "w-20"}`}>
        {children}
      </div>
    </div>
  );
}

export function DateAndTime({ formProp, setFormProp }: formInterface) {
  return (
    <div className="w-full">
      <Label className="text-right mb-2">Date and Time *</Label>
      <div id="dialog" className="w-full relative">
        <DatePicker
          value={formProp.date}
          setValue={(e: FormEvent<any>) => handleFormChange(e, setFormProp)}
        />
        <Input
          id="time"
          name="time"
          type="time"
          value={formProp.time}
          required
          onChange={(e: FormEvent<HTMLInputElement>) =>
            handleFormChange(e, setFormProp)
          }
          className="w-22 absolute bottom-0 right-0 z-50"
        />
      </div>
    </div>
  );
}

export function BaseTextArea({
  id,
  label,
  value,
  placeholder,
  required = false,
  setProp,
}: input) {
  return (
    <div className="w-full">
      <Label htmlFor={id} className="text-right mb-2">
        {label} {required && "*"}
      </Label>
      <Textarea
        id={id}
        name={id}
        value={value}
        placeholder={placeholder || "Type something..."}
        onChange={(e: FormEvent<HTMLTextAreaElement>) =>
          handleFormChange(e, setProp)
        }
        maxLength={2000}
      />
      <div className="flex justify-end">
        <p className="text-sm text-gray-400">{value?.length || 0} / 2000</p>
      </div>
    </div>
  );
}

export function BaseSelect({
  id,
  value,
  setValue,
  resource,
  dataProp,
  label,
  required,
}: baseSelect) {
  return (
    <div className="w-full">
      <Label htmlFor={id} className="mb-2">
        {label} {required && "*"}
      </Label>
      <SelectFinal
        id={id}
        value={value}
        setValue={(e: FormEvent<HTMLSelectElement>) =>
          handleFormChange(e, setValue)
        }
        resource={resource}
        dataProp={dataProp}
        required={required}
      />
    </div>
  );
}

export function BaseStaticSelect({id, label, value, setValue, required, data, disabled=false}: baseStaticSelect) {
  return (
    <div className="w-full">
      <Label htmlFor={id} className="mb-2">
        {label} {required && "*"}
      </Label>
      <StaticDataSelect 
        id={id}
        value={value}
        setValue={(e: FormEvent<HTMLSelectElement>) =>
          handleFormChange(e, setValue)
        }
        data={data}
        required={required}
        disabled={disabled}
      />
    </div>
  )
}